import { actionTypes as bookmakersInfoActionTypes } from './bookmakersInfo.actions';
import cleanStakeInput from '../utils/cleanStakeInput';

const initialState = {
    isEditingStake: false,
    stakeValue: '',
    isEachWay: false,
    error: {
        errorId: null,
        message: null,
    },
};

const determineStake = (newStake, exisitngStake) => {
    const formattedStake = cleanStakeInput(newStake)
    const parsed = parseFloat(formattedStake)
    const stakeNumber = isNaN(parsed) ? 0 : parsed

    return stakeNumber <= 99999.99 ? formattedStake : exisitngStake
}

const reorderBetSelections = (betSelections, index, selectionId) => {
    const reorderedSelections = betSelections;
    const roundedIndex = Math.round(index);
    const selectIndex = betSelections.findIndex(
        bet => (bet.selectionId === selectionId),
    );

    switch (roundedIndex) {
        case 1:
            if (selectIndex + roundedIndex < reorderedSelections.length) {
                const selection = reorderedSelections[selectIndex];
                reorderedSelections[selectIndex] = reorderedSelections[
                    selectIndex + roundedIndex
                ];
                reorderedSelections[selectIndex + roundedIndex] = selection;
            }
            break;
        case -1:
            if (selectIndex + roundedIndex >= 0) {
                const selection = reorderedSelections[selectIndex];
                reorderedSelections[selectIndex] = reorderedSelections[
                    selectIndex + roundedIndex];
                reorderedSelections[selectIndex + roundedIndex] = selection;
            }
            break;
        default:
            return reorderedSelections;
    }

    return reorderedSelections;
}

/* eslint-disable default-case, consistent-return */
export default (state, multiple, action) => {
    let betSelections
    let previousStake
    let previousEachWay

    switch (action.type) {

        case bookmakersInfoActionTypes.SET_MULTIPLES:

            betSelections = multiple.betSelections.map(bet => ({
                selectionId: bet.selectionId,
                marketId: bet.marketId,
                eventId: bet.eventId,
            }));

            return {
                ...initialState,
                betType: multiple.betType,
                maxStake: multiple.maxStake,
                minStake: multiple.minStake,
                numberLines: multiple.numberLines,
                optionId: multiple.optionId,
                betSelections,
            }

        case bookmakersInfoActionTypes.SET_STAKE_FOR_MULTIPLE:

            if (multiple.optionId !== action.optionId) return { ...multiple }

            return {
                ...multiple,
                stakeValue: determineStake(action.stake, multiple.stakeValue),
            };

        case bookmakersInfoActionTypes.SET_IS_EDITING_STAKE_FOR_MULTIPLE:

            if (multiple.optionId !== action.optionId) {
                return {
                    ...multiple,
                    isEditingStake: false,
                };
            }

            return {
                ...multiple,
                isEditingStake: action.isEditingStake,
            };

        case bookmakersInfoActionTypes.SET_IS_EACHWAY_FOR_MULTIPLE:

            if (multiple.optionId !== action.optionId) return { ...multiple }

            return {
                ...multiple,
                isEachWay: action.isEachWay,
            };

        case bookmakersInfoActionTypes.SET_MULTIPLES_ERROR:

            if (multiple.optionId !== action.optionId) return { ...multiple }

            return {
                ...multiple,
                error: action.error,
            }

        case bookmakersInfoActionTypes.CLEAR_MULTIPLES_ERROR:

            if (multiple.optionId !== action.optionId) return { ...multiple }

            return {
                ...multiple,
                error: {
                    errorId: null,
                    message: null,
                },
            }

        case bookmakersInfoActionTypes.CLEAR_ALL_MULTIPLES_ERRORS:
            return {
                ...multiple,
                error: {
                    errorId: null,
                    message: null,
                },
            }

        case bookmakersInfoActionTypes.RESTORE_MULTIPLES_STAKES:
            previousStake = state.multiplesStakes.find(
                multipleStake => multipleStake.optionId === multiple.optionId,
            )

            if (!previousStake) return { ...multiple }

            return {
                ...multiple,
                stakeValue: determineStake(previousStake.stake, multiple.stakeValue),
            }

        case bookmakersInfoActionTypes.RESTORE_MULTIPLES_EACHWAY:
            previousEachWay = state.multiplesEachWay.find(
                multipleEachWay => multipleEachWay.optionId === multiple.optionId,
            )

            if (!previousEachWay) return { ...multiple }

            return {
                ...multiple,
                isEachWay: previousEachWay.isEachWay,
            }

        case bookmakersInfoActionTypes.CHANGE_SELECTION_ORDER:

            if (multiple.optionId !== action.optionId) {
                return { ...multiple };
            }

            return {
                ...multiple,
                betSelections: reorderBetSelections(
                    multiple.betSelections,
                    action.index,
                    action.selectionId,
                ),
            };
    }
}
/* eslint-enable default-case, consistent-return */



// WEBPACK FOOTER //
// /src/js/common/bookmakersInfo/bookmakersInfo.multiples.reducer.js